import AadharVerify from "../../../assets/aadhar_verify.svg";
import MobileVerify from "../../../assets/mobile_verify.svg";

export const ABHA_VERIFICATION_OPTIONS = [
  {
    id: 1,
    label: "Verify with Mobile Number OTP",
    icon: MobileVerify,
    value: "MOBILE_OTP",
  },
  {
    id: 2,
    label: "Verify with Aadhar OTP",
    icon: AadharVerify,
    value: "AADHAAR_OTP",
  },
];

export const GENDER_OPTIONS = [
  {
    id: 1,
    label: "Male",
    value: "Male",
    selected: false,
  },
  {
    id: 1,
    label: "Female",
    value: "Female",
    selected: false,
  },
  {
    id: 1,
    label: "Others",
    value: "Others",
    selected: true,
  },
];

export const ERRORSINTIAL = {
  patientName: "",
  email: "",
  patientAddress: "",
  pincode: "",
  gender: "",
  uhid: "",
};

export const CONSULTATIONTYPE = {
  INCLINIC: "in-clinic",
  TELECONSULT: "Tele-Consult",
  REGULAR: "Regular",
  FOLLOWUP: "followup",
  FOLLOW_UP: "Follow-Up",
  PROCEDURE: "procedure",
  INSTANT: "instant",
  ONLINE: "online",
};

export const UHID_DUPLICATE_ERROR =
  "This record is already exists, please enter unique record.";

export const getUHIDFormatError = (uhIDPrefix) => {
  return `Kindly enter valid UHID Ex- ${uhIDPrefix ? uhIDPrefix : "ABC"}0001`;
};

export const UHID_SINGLE_QUOTES_ERROR =
  "UHID field cannot take single & double quotes. Kindly enter something else.";
